<template>
  <div class="top-loading-bar" :class="{ 'top-loading-bar--active': isLoading }" aria-hidden="true">
    <div class="top-loading-bar__track">
      <div class="top-loading-bar__indicator" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const isLoading = computed(() => store.getters.getPending)
</script>

<style scoped lang="scss">
.top-loading-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  height: 3px;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;

  &--active {
    opacity: 1;
  }

  &__track {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: rgba(50, 31, 219, 0.12);
  }

  &__indicator {
    position: absolute;
    top: 0;
    left: 0;
    width: 35%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(50, 31, 219, 0.15),
      var(--cui-primary, #321fdb),
      rgba(50, 31, 219, 0.15)
    );
    animation: top-loading-bar-slide 1.1s ease-in-out infinite;
  }
}

@keyframes top-loading-bar-slide {
  0% {
    transform: translateX(-120%);
  }

  100% {
    transform: translateX(320%);
  }
}
</style>
